import { currentLanguage, luxonLocale } from "../../i18n";

export const formatLocale = () => luxonLocale(currentLanguage());

const decimals = new Map<string, string>();
const groups = new Map<string, string>();

export function decimalSeparator(): string {
  const locale = formatLocale();
  let decimal = decimals.get(locale);
  if (decimal === undefined) {
    decimal = new Intl.NumberFormat(locale).formatToParts(1.5).find(part => part.type === "decimal")?.value ?? ".";
    decimals.set(locale, decimal);
  }
  return decimal;
}

export function groupSeparator(): string {
  const locale = formatLocale();
  let group = groups.get(locale);
  if (group === undefined) {
    group = new Intl.NumberFormat(locale).formatToParts(1234567).find(part => part.type === "group")?.value ?? ",";
    groups.set(locale, group);
  }
  return group;
}
